import type { IJobListResponse, IJobResponse, ICreateJob } from '@escloud/types';

import type { ApiClient } from './api-client';

export class JobsService {
    constructor(private api: ApiClient) {}

    list(caseId: string): Promise<IJobListResponse> {
        return this.api.get<IJobListResponse>(`/cases/${caseId}/jobs`);
    }

    getById(caseId: string, jobId: string): Promise<IJobResponse> {
        return this.api.get<IJobResponse>(`/cases/${caseId}/jobs/${jobId}`);
    }

    create(caseId: string, data: ICreateJob): Promise<IJobResponse> {
        return this.api.post<IJobResponse>(`/cases/${caseId}/jobs`, data);
    }
}
